/**
 * Select which node IDs the Flow Designer should fetch cache-row playbooks for.
 *
 * A node qualifies when it has authored `playbookSteps` on its configJson OR
 * when it already has a cache row (`hasCachedReplay`). The cache-row arm is
 * load-bearing under playbook-v3: there the playbook lives ONLY on the cache row
 * (config_json is frozen), so a configJson-only gate would exclude every v3
 * node and its steps would never be fetched or rendered. The fetched rows feed
 * `resolveCachePlaybookNodes`, which swaps each row's `playbook_json` into the
 * viewer.
 *
 * @module FlowDesigner/utils/selectPlaybookFetchNodeIds
 */

import type { PlaybookStep } from '@chatsdet/types';

type NodeLike = { id: string; data?: Record<string, unknown> | null };

export function selectPlaybookFetchNodeIds(nodes: NodeLike[]): string[] {
  const ids: string[] = [];
  for (const node of nodes) {
    const data = (node.data ?? {}) as Record<string, unknown>;
    const steps = data.playbookSteps as PlaybookStep[] | undefined;
    const hasConfigSteps = Array.isArray(steps) && steps.length > 0;
    const hasCacheRow = data.hasCachedReplay === true;
    if (hasConfigSteps || hasCacheRow) ids.push(node.id);
  }
  return ids;
}
